module.exports = __webpack_public_path__ + "img/58.5e56cdb9.jpg";